import dateFns from 'date-fns'

import AppPage from '../../mixins/app-page'
import AppImg from '../app-img'
import AppBtnFilter from '../app-btn-filter'
import AppHexagon from '../app-hexagon'
import AppBtn from '../app-btn'
import AppMatchesTableTr from '../app-matches-table-tr'
import AppArrowLink from '../app-arrow-link'
import AppBtnSocialLink from '../app-btn-social-link'


// URL list
import URL from '../../../config.url'


export default
{
    name: 'page-team-profile',

    mixins:
    [
        AppPage
    ],

    components:
    {
        AppImg,
        AppBtnFilter,
        AppHexagon,
        AppBtn,
        AppMatchesTableTr,
        AppArrowLink,
        AppBtnSocialLink
    },

    data()
    {
        return {
            currentGameId: -1,
            players: [],
            lasts: [],
            nexts: [],
            url: URL,
            teamIndex: -1,
            games: this.contentGlobal.videoGames,
            currentHeadsOfTable: []
        }
    },

    computed:
    {
        teamGames()
        {
            const games = []

            for (let i = 0, l = this.contentPage.games.length; i < l; i += 1)
            {
                for (let j = 0, m = this.contentGlobal.videoGamesAll.length; j < m; j += 1)
                {
                    if (this.contentPage.games[i] === this.contentGlobal.videoGamesAll[j].id)
                    {
                        games.push(this.contentGlobal.videoGamesAll[j])
                    }
                }
            }

            return games
        },

        headOfStatsTable()
        {
            const table = []
            const heads = this.contentPage.players.head

            for (let i = 0, l = heads.length; i < l; i += 1)
            {
                if (typeof heads[i] === 'string')
                {
                    table.push(heads[i])
                }
                else if (typeof heads[i] === 'object')
                {
                    const arr = Object.keys(heads[i])
                    const arrTable = []

                    for (let j = 0, m = arr.length; j < m; j += 1)
                    {
                        arrTable.push(heads[i][arr[j]])
                    }

                    table.push(arrTable)
                }
            }

            return table
        }
    },

    watch:
    {
        currentGameId(id)
        {
            const playerList = JSON.parse(JSON.stringify(this.contentPage.players.list))
            const lastList = JSON.parse(JSON.stringify(this.contentPage.prevMatches.list))
            const nextList = JSON.parse(JSON.stringify(this.contentPage.nextMatches.list))

            this.players = playerList.filter(player => player.videoGameID === id)
            this.lasts = lastList.filter(match => match.videoGameID === id)
            this.nexts = nextList.filter(match => match.videoGameID === id)

            this.currentHeadsOfTable.length = 0
            this.currentHeadsOfTable = []

            for (let i = 0, l = this.headOfStatsTable.length; i < l; i += 1)
            {
                const head = this.headOfStatsTable[i]

                if (typeof head === 'string')
                {
                    this.currentHeadsOfTable.push({
                        label: head,
                        align: 'left'
                    })
                }
                else if (typeof head === 'object')
                {
                    for (let j = 0, m = head.length; j < m; j += 1)
                    {
                        if (head[j].videoGameID === this.currentGameId)
                        {
                            for (let k = 0, n = head[j].list.length; k < n; k += 1)
                            {
                                this.currentHeadsOfTable.push({
                                    label: head[j].list[k],
                                    align: 'center'
                                })
                            }
                        }
                    }
                }
            }
        }
    },

    created()
    {
        const currentGame = this.params.filter ? this.contentGlobal.videoGamesAll.find(game => game.slug === this.params.filter) : null

        this.contentGlobal.teamsAll.forEach((team, index) =>
        {
            if (team.slug === this.$route.params.slug)
            {
                this.teamIndex = index
            }
        })


        if (currentGame)
        {
            this.currentGameId = currentGame.id
        }
        else
        {
            this.currentGameId = this.contentPage.games[0]
        }
    },

    mounted()
    {
        this.eventHub.$emit('bg-change', this.contentGlobal.videoGamesAll.find(game => parseInt(game.id, 10) === this.currentGameId).cover)
    },

    methods:
    {
        goto(url)
        {
            this.$root.changePage(url)
        },

        _onResize()
        {
            this.$emit('load', this)
        },

        openModalRegister()
        {
            this.$root.openModalPlay('team', this.contentPage.observeId)
        },

        getVideoGameFromID(id)
        {
            return this.contentGlobal.videoGamesAll.find(game => parseInt(game.id, 10) === id)
        },

        getScoreById(id)
        {
            return this.contentPage.scores.list.find(score => score.videoGameID === id)
        },

        getYears(timestamp)
        {
            return dateFns.differenceInYears(Date.now(), timestamp * 1000)
        },

        filterVideoGame(id)
        {
            this.currentGameId = id

            this.eventHub.$emit('bg-change', this.contentGlobal.videoGamesAll.find(game => parseInt(game.id, 10) === id).cover)
        },

        _getTeamNameFromID(index)
        {
            return this.contentGlobal.teams[index] ? this.contentGlobal.teams[index].name : ''
        },

        _getPreviousNextTeamFromID(index)
        {
            if (this.contentGlobal.teamsAll[index]
                && this.contentGlobal.teamsAll[index].seasonID === this.contentGlobal.teamsAll[this.teamIndex].seasonID)
            {
                return this.$root.getPageURLFromID('teamProfile').replace(':slug', this.contentGlobal.teamsAll[index].slug)
            }

            return null
        },

        _getTeamURLFromID(index)
        {
            if (this.contentGlobal.teamsAll[index])
            {
                return this.$root.getPageURLFromID('teamProfile').replace(':slug', this.contentGlobal.teamsAll[index].slug)
            }


            return this.$route.path
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/page-team-profile/script.js